import { t, Trans } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropDefaults, panelPropTypes } from '../../page-framework/panel/PanelPropTypes';
import FixedLabelContainer, { Row } from '../../fixed-label-container/FixedLabelContainer';
import StatusBreakoutRow from '../../status-breakout/StatusBreakoutRow';
import { hypervisorFilterId, timeRangeFilterId, useHypervisor } from '../../filters';
import usePanelDataService from '../../../services/PanelDataService';

const title = t`Hypervisor Virtual Machines Status`;

const dataSource = {
    url: '/query/table',
    params: {
        type: 'hypervisor',
        metrics: ['hpvVMCounts'],
        trends: ['hpvVMCounts'],
        renderAsEntity: true,
    },
};

function HypervisorVmStatusBreakoutPanel() {
    const hypervisor = useHypervisor();
    const statusCounts = usePanelDataService(dataSource);
    const statusData = statusCounts?.data?.[0];

    if (!hypervisor || !statusCounts) return null;

    return (
        <FixedLabelContainer>
            <Row>
                <StatusBreakoutRow
                    noSelection
                    disableSelection
                    page="/vmware-vms"
                    title={<Trans>Virtual Machines</Trans>}
                    metric="hpvVMCounts"
                    last=""
                    data={statusData}
                    hideProblems
                />
            </Row>
        </FixedLabelContainer>
    );
}

HypervisorVmStatusBreakoutPanel.propTypes = panelPropTypes;

HypervisorVmStatusBreakoutPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    autoHeight: true,
    minContentHeight: 110,
};

export default Panel({
    typeAlias: 'VmwareVmStatusBreakout',
    catalogEntry: {
        category: PANEL_CATEGORIES.HYPERVISOR,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status breakdown for the virtual machines (VMs) on a selected hypervisor`,
        previewImage: STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, hypervisorFilterId],
        optional: [],
    },
})(HypervisorVmStatusBreakoutPanel);
